import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { MetricsBar } from './components/MetricsBar';
import { PainPoints } from './components/PainPoints';
import { Achievements } from './components/Achievements';
import { BigMistake } from './components/BigMistake';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { ProductPresentation } from './components/ProductPresentation';
import { LimitedOffer } from './components/LimitedOffer';
import { BonusSection } from './components/BonusSection';
import { OfferSummary } from './components/OfferSummary';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { CTABreak } from './components/CTABreak';
import { TransformationSection } from './components/TransformationSection';
export function App() {
  return <div className="min-h-screen flex flex-col font-body" data-id="element-0">
      <StickyAlertBar data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <CTABreak data-id="element-5" />
        <BigMistake data-id="element-6" />
        <UniqueMechanism data-id="element-7" />
        <TransformationSection data-id="element-8" />
        <WhatIsIncluded data-id="element-9" />
        <CTABreak data-id="element-10" />
        <ProductPresentation data-id="element-11" />
        <Achievements data-id="element-12" />
        <BonusSection data-id="element-13" />
        <CTABreak data-id="element-14" />
        <Testimonials data-id="element-15" />
        <FAQ data-id="element-16" />
        <LimitedOffer data-id="element-17" />
        <OfferSummary data-id="element-18" />
        <Guarantee data-id="element-19" />
        <OfferSummary data-id="element-20" />
        <FinalCTA data-id="element-21" />
      </main>

      <Footer data-id="element-22" />
    </div>;
}